import Vue from 'vue';
import Router from 'vue-router';

import acl from '@/utils/accessLevels';

// Login related components
const RequestAccess = () => import(/* webpackChunkName: "RequestAccess" */ '@/components/Login/RequestAccess');
const Login = () => import(/* webpackChunkName: "Login" */ '@/components/Login/Login');
const SetPassword = () => import(/* webpackChunkName: "SetPassword" */ '@/components/Login/SetPassword');
// const ForgotPassword = () => import(/* webpackChunkName: "ForgotPassword" */ '@/components/Login/ForgotPassword');

const AppWrapper = () => import(/* webpackChunkName: "AppWrapper" */ '@/components/AppWrapper');

// Syndicate related components
const Syndicates = () => import(/* webpackChunkName: "Syndicates" */ '@/components/Syndicates/Syndicates');
const SyndicateListing = () => import(/* webpackChunkName: "SyndicateListing" */ '@/components/Syndicates/Listing/SyndicateListing');
const Syndicate = () => import(/* webpackChunkName: "Syndicate" */ '@/components/Syndicates/Syndicate/Syndicate');
const SyndicateDashboard = () => import(/* webpackChunkName: "SyndicateDashboard" */ '@/components/Syndicates/Syndicate/Dashboard/Dashboard');
const EditSyndicate = () => import(/* webpackChunkName: "EditSyndicate" */ '@/components/Syndicates/Syndicate/EditSyndicate');
const AddSyndicate = () => import(/* webpackChunkName: "AddSyndicate" */ '@/components/Syndicates/Syndicate/AddSyndicate');
// const Document = () => import(/* webpackChunkName: "AddSyndicate" */ '@/components/Syndicates/Syndicate/Document');

const Transactions = () => import(/* webpackChunkName: "Transactions" */ '@/components/Syndicates/Syndicate/Transactions/Transactions');
const SyndicateTransactions = () => import(/* webpackChunkName: "SyndicateTransactions" */ '@/components/Syndicates/Syndicate/Transactions/Listing/TransactionListing');
const SyndicateBudget = () => import(/* webpackChunkName: "SyndicateBudget" */ '@/components/Syndicates/Syndicate/Budget/Budget');

const Accounts = () => import(/* webpackChunkName: "Accounts" */ '@/components/Syndicates/Syndicate/Accounts/Accounts');
const AccountListing = () => import(/* webpackChunkName: "AccountListing" */ '@/components/Syndicates/Syndicate/Accounts/Listing/AccountListing');
const Coowners = () => import(/* webpackChunkName: "Coowners" */ '@/components/Syndicates/Syndicate/Coowners/Coowners');
const CoownerListing = () => import(/* webpackChunkName: "CoownerListing" */ '@/components/Syndicates/Syndicate/Coowners/Listing/CoownerListing');
const Coowner = () => import(/* webpackChunkName: "Coowner" */ '@/components/Syndicates/Syndicate/Coowners/Coowner/Coowner');
const EditCoowner = () => import(/* webpackChunkName: "EditCoowner" */ '@/components/Syndicates/Syndicate/Coowners/Coowner/EditCoowner');
const AddCoowner = () => import(/* webpackChunkName: "AddCoowner" */ '@/components/Syndicates/Syndicate/Coowners/Coowner/AddCoowner');
const AddAccount = () => import(/* webpackChunkName: "AddAccount" */ '@/components/Syndicates/Syndicate/Accounts/Account/AddAccount');

const SettingsCoowner = () => import(/* webpackChunkName: "Coowners" */ '@/components/Syndicates/Syndicate/CoownerSettings/CoownerSettings');
const AddCoownerSettings = () => import(/* webpackChunkName: "EditCoowner" */ '@/components/Syndicates/Syndicate/CoownerSettings/AddCoownerSettings');

// Reports related components
const Reports = () => import(/* webpackChunkName: "Reports" */ '@/components/Syndicates/Syndicate/Reports/Reports');
const ReportsPage = () => import(/* webpackChunkName: "ReportsPage" */ '@/components/Syndicates/Syndicate/Reports/ReportsPage');
const SOI = () => import(/* webpackChunkName: "SOI" */ '@/components/Syndicates/Syndicate/Reports/SOI/SOI');
const GeneralLedger = () => import(/* webpackChunkName: "GeneralLedger" */ '@/components/Syndicates/Syndicate/Reports/GeneralLedger/GeneralLedger');
const BalanceSheet = () => import(/* webpackChunkName: "BalanceSheet" */ '@/components/Syndicates/Syndicate/Reports/BalanceSheet/BalanceSheet');
const DRD = () => import(/* webpackChunkName: "DRD" */ '@/components/Syndicates/Syndicate/Reports/DRD/DRD');
const TaxesReport = () => import(/* webpackChunkName: "TaxesReport" */ '@/components/Syndicates/Syndicate/Reports/Taxes/Taxes');

// User related components
const Users = () => import(/* webpackChunkName: "Users" */ '@/components/Users/Users');
const UserListing = () => import(/* webpackChunkName: "UserListing" */ '@/components/Users/Listing/UserListing');
// const User = () => import(/* webpackChunkName: "User" */ '@/components/Users/User/User');
const AddUser = () => import(/* webpackChunkName: "AddUser" */ '@/components/Users/User/AddUser');
const EditUser = () => import(/* webpackChunkName: "EditUser" */ '@/components/Users/User/EditUser');
const ChangePassword = () => import(/* webpackChunkName: "ChangePassword" */ '@/components/Users/User/ChangePassword');

// Settings
const UserSettings = () => import(/* webpackChunkName: "UserSettings" */ '@/components/Settings/User/UserSettings');

// Taxes
const Taxes = () => import(/* webpackChunkName: "Taxes" */ '@/components/Syndicates/Syndicate/Taxes/Taxes');
const TaxForm = () => import(/* webpackChunkName: "TaxForm" */ '@/components/Syndicates/Syndicate/Taxes/Tax/TaxForm');
const TaxListing = () => import(/* webpackChunkName: "TaxListing" */ '@/components/Syndicates/Syndicate/Taxes/Listing/TaxListing');

// Building description
// const BuildingDescription = () => import(/* webpackChunkName: "BuildingDescription" */ '@/components/Syndicates/Syndicate/BuildingDescription/BuildingDescription');
// const BuildingDescriptionForm = () => import(/* webpackChunkName: "BuildingDescriptionForm" */ '@/components/Syndicates/Syndicate/BuildingDescription/DescriptionForm');

// Information

const Calender = () => import(/* webpackChunkName: "Calender" */'@/components/Syndicates/Syndicate/Information/Calendar/Calender');

const News = () => import(/* webpackChunkName: "News" */ '@/components/Syndicates/Syndicate/Information/News/News');
const NewsListing = () => import(/* webpackChunkName: "News" */ '@/components/Syndicates/Syndicate/Information/News/NewsListing');
const AddNews = () => import(/* webpackChunkName: "Add News" */ '@/components/Syndicates/Syndicate/Information/News/AddNews');

const FAQ = () => import('@/components/Syndicates/Syndicate/Information/FAQs/FAQs');
const FAQListing = () => import('@/components/Syndicates/Syndicate/Information/FAQs/FAQsList');
const AddFAQ = () => import('@/components/Syndicates/Syndicate/Information/FAQs/AddFAQs');

const AgmPage = () => import(/* webpackChunkName: "ReportsPage" */ '@/components/Syndicates/Syndicate/Reports/AGM/Aga');
// const EditNews = () => import(/* webpackChunkName: "Edit News" */);
const NotFound = () => import(/* webpackChunkName: "NotFound" */ '@/components/NotFound');

const Notices = () => import('@/components/Syndicates/Syndicate/Information/Notices/Notices');
const NoticeListing = () => import('@/components/Syndicates/Syndicate/Information/Notices/NoticeListing');
const AddNotice = () => import('@/components/Syndicates/Syndicate/Information/Notices/AddNotice');

// companies
// const Companies = () => import('@/components/Syndicates/Syndicate/Companies/Companies');
// const AddCompany = () => import('@/components/Syndicates/Syndicate/Companies/Company/AddCompany');
const Companies = () => import('@/components/Syndicates/Syndicate/Companies/Companies');
const AddCompany = () => import('@/components/Syndicates/Syndicate/Companies/Company/AddCompany');
const Company = () => import('@/components/Syndicates/Syndicate/Companies/Company/Company');
const EditCompany = () => import('@/components/Syndicates/Syndicate/Companies/Company/EditCompany');
const ReviewListing = () => import('@/components/Syndicates/Syndicate/Companies/Listing/ReviewListing');

// Bank staement
const BankStatement = () => import('@/components/Syndicates/Syndicate/BankStatement/BankStatement');
const BankStatementListing = () => import('@/components/Syndicates/Syndicate/BankStatement/Listing/BankStatementListing');
const AddBankStatement = () => import('@/components/Syndicates/Syndicate/BankStatement/BankStatement/AddBankStatement');

// Suggested PF Fund
const SuggestedPF = () => import('@/components/Syndicates/Syndicate/SuggestedPF/SuggestedPF');
const AddSuggestedPF = () => import('@/components/Syndicates/Syndicate/SuggestedPF/SuggestedPF/AddSuggestedPF');
const SuggestedPFListing = () => import('@/components/Syndicates/Syndicate/SuggestedPF/Listing/SuggestedPFListing');

const Forum = () => import('@/components/Syndicates/Syndicate/Forum/Forum');

// Link
const Links = () => import('@/components/Syndicates/Syndicate/Links/Links');


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/request-access',
      name: 'Request Access',
      component: RequestAccess,
    },
    {
      path: '/set-password',
      name: 'Set Password',
      component: SetPassword,
    },
    // {
    //   path: '/forgot-password',
    //   name: 'Forgot Password',
    //   component: ForgotPassword,
    // },
    { path: '/', redirect: '/syndicates' },
    {
      path: '/',
      component: AppWrapper,
      children: [
        {
          path: 'syndicates',
          component: Syndicates,
          children: [
            {
              path: 'add',
              name: 'Add Syndicate',
              component: AddSyndicate,
              meta: { userAccess: acl.super },
            },
            {
              path: ':syndicateID',
              component: Syndicate,
              children: [
                {
                  path: '',
                  name: 'Syndicate Dashboard',
                  component: SyndicateDashboard,
                },
                // {
                //   path: 'document',
                //   name: 'Document',
                //   component: Document,
                // },
                {
                  path: 'transactions',
                  component: Transactions,
                  children: [
                    {
                      path: '',
                      name: 'Accounting Transactions',
                      component: SyndicateTransactions,
                      meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'budget',
                  name: 'Accounting Budget',
                  component: SyndicateBudget,
                  meta: { userAccess: acl.superAndManager },
                },
                {
                  path: 'drd-form',
                  name: 'Accounting DRD',
                  component: DRD,
                  meta: { userAccess: acl.superAndManager },
                },
                {
                  path: 'reports',
                  component: Reports,
                  children: [
                    {
                      path: 'general-ledger',
                      name: 'Accounting General Ledger',
                      component: GeneralLedger,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: 'balance-sheet',
                      name: 'Accounting Balance Sheet',
                      component: BalanceSheet,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: 'income-statement',
                      name: 'Accounting Income Statement',
                      component: SOI,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: 'taxes',
                      name: 'Reports Taxes',
                      component: TaxesReport,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: 'export',
                      name: 'Reports Export',
                      component: ReportsPage,
                    },
                    {
                      path: 'agmpresence',
                      name: 'Reports AGM Attendance',
                      component: AgmPage,
                    },
                  ],
                },
                {
                  path: 'edit',
                  name: 'Settings Edit Syndicate',
                  component: EditSyndicate,
                  meta: { userAccess: acl.superAndManager },
                },
                {
                  path: 'calender',
                  name: 'Information Calender',
                  component: Calender,
                  // meta: { userAccess: acl.superAndManager },
                  // component: Accounts,
                  children: [
                    {
                      path: 'calender',
                      name: 'Information Calender',
                      component: Calender,
                      // meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'news',
                  component: News,
                  children: [
                    {
                      path: '',
                      name: 'Information News',
                      component: NewsListing,
                      // meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':id',
                      name: 'Add News',
                      component: AddNews,
                      // meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'notices',
                  component: Notices,
                  children: [
                    {
                      path: '',
                      name: 'Information Notices',
                      component: NoticeListing,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':id',
                      name: 'Add Notice',
                      component: AddNotice,
                      meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'faq',
                  component: FAQ,
                  children: [
                    {
                      path: '',
                      name: 'Information FAQ Listing',
                      component: FAQListing,
                      meta: { userAccess: acl.all },
                    },
                    {
                      path: ':id',
                      name: 'Add FAQs',
                      component: AddFAQ,
                      meta: { userAccess: acl.super },
                    },
                  ],
                },
                {
                  path: 'forum',
                  name: 'Information Forum Page',
                  component: Forum,
                  meta: { userAccess: acl.superAndManager },
                },
                {
                  path: 'accounts',
                  component: Accounts,
                  children: [
                    {
                      path: '',
                      name: 'Settings Accounts',
                      component: AccountListing,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: 'add',
                      name: 'Add Account',
                      component: AddAccount,
                      meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'statement',
                  component: BankStatement,
                  children: [
                    {
                      path: '',
                      name: 'Settings Bank Statement',
                      component: BankStatementListing,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':id',
                      name: 'Add BankStatement',
                      component: AddBankStatement,
                      // meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'links',
                  name: 'Settings Links',
                  component: Links,
                  meta: { userAccess: acl.superAndManager },
                },
                {
                  path: 'suggestedpf',
                  component: SuggestedPF,
                  children: [
                    {
                      path: '',
                      name: 'Settings Suggested PF',
                      component: SuggestedPFListing,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':id',
                      name: 'Add Suggested PF',
                      component: AddSuggestedPF,
                      meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: '',
                  component: SettingsCoowner,
                  children: [
                    {
                      path: 'coownersetting',
                      name: 'Settings',
                      component: AddCoownerSettings,
                      meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                {
                  path: 'companies',
                  component: Companies,
                  children: [
                    {
                      path: 'add',
                      name: 'Add Company',
                      component: AddCompany,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':companiesReviewID',
                      name: 'Company',
                      component: Company,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':companiesReviewID/edit',
                      name: 'Edit Company',
                      component: EditCompany,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: '',
                      name: 'Coowner Review Listing',
                      component: ReviewListing,
                    },
                  ],
                },
                {
                  path: 'taxes',
                  component: Taxes,
                  children: [
                    {
                      path: '',
                      name: 'Settings Taxes',
                      component: TaxListing,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: 'add',
                      name: 'Add Tax',
                      component: TaxForm,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':taxID',
                      name: 'Edit Tax',
                      component: TaxForm,
                      meta: { userAccess: acl.superAndManager },
                    },
                  ],
                },
                // {
                //   path: 'description',
                //   component: BuildingDescription,
                //   children: [
                //     {
                //       path: '',
                //       name: 'Settings Building description',
                //       component: BuildingDescriptionForm,
                //       meta: { userAccess: acl.superAndManager },
                //     },
                //   ],
                // },
                {
                  path: 'coowners',
                  component: Coowners,
                  children: [
                    {
                      path: 'add',
                      name: 'Add Coowner',
                      component: AddCoowner,
                      meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':coownerID',
                      name: 'Coowner',
                      component: Coowner,
                      // meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: ':coownerID/edit',
                      name: 'Edit Coowner',
                      component: EditCoowner,
                      // meta: { userAccess: acl.superAndManager },
                    },
                    {
                      path: '',
                      name: 'Coowner Listing',
                      component: CoownerListing,
                    },
                  ],
                },
              ],
            },
            {
              path: '',
              name: 'Syndicate Listing',
              component: SyndicateListing,
            },
          ],
        },
        {
          path: '/users',
          component: Users,
          children: [
            {
              path: 'add',
              name: 'Add User',
              component: AddUser,
              meta: { userAccess: acl.superAndManager },
            },
            // {
            //   path: ':userID',
            //   name: 'User',
            //   component: User,
            // },
            {
              path: ':userID',
              name: 'Edit User',
              component: EditUser,
              meta: { userAccess: acl.superAndManager },
            },
            {
              path: '',
              name: 'User Listing',
              component: UserListing,
              meta: { userAccess: acl.superAndManager },
            },
          ],
        },
        {
          path: '/settings',
          name: 'User Settings',
          component: UserSettings,
        },
        {
          path: '/change-password',
          name: 'Change Password',
          component: ChangePassword,
        },
        {
          path: '*',
          component: NotFound,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js